var makeString = require("./helper/makeString");
var from = "\u0105\xE0\xE1\xE4\xE2\xE3\xE5\xE6\u0103\u0107\u010D\u0109\u0119\xE8\xE9\xEB\xEA\u011D\u0125\xEC\xED\xEF\xEE\u0135\u0142\u013E\u0144\u0148\xF2\xF3\xF6\u0151\xF4\xF5\xF0\xF8\u015B\u0219\u015F\u0161\u015D\u0165\u021B\u0163\u016D\xF9\xFA\xFC\u0171\xFB\xF1\xFF\xFD\xE7\u017C\u017A\u017E", to = "aaaaaaaaaccceeeeeghiiiijllnnoooooooossssstttuuuuuunyyczzz";
from += from.toUpperCase();
to += to.toUpperCase();
to = to.split("");
from += "\xDF";
to.push("ss");
module.exports = function cleanDiacritics(str) {
  return makeString(str).replace(/.{1}/g, function(c) {
    var index = from.indexOf(c);
    return index === -1 ? c : to[index];
  });
};
